const steps = [
  {
    label: 'Goal',
    value: 'goal',
  },
  {
    label: 'Story',
    value: 'story',
  },
  {
    label: 'Photo & Video',
    value: 'photo',
  },
  {
    label: 'Share',
    value: 'share',
  },
];

export const ProgressBar = ({ selectedStep }) => {
  const selectedStepIndex = steps.findIndex((x) => x.value == selectedStep);
  const className = (i) => {
    return i <= selectedStepIndex ? 'highlighted' : '';
  };
  return (
    <div className='registration-progress-bar'>
      {steps.map((step, i) => {
        return (
          <div key={i} className={className(i)}>
            {step.label}
          </div>
        );
      })}
    </div>
  );
};
